import { AnalyticsAdapter } from "./adapter";
import { TrackParams } from "./types";

class AnalyticsCore {
  private adapter: AnalyticsAdapter | null = null;
  private enabled = false;
  private isProd = false;

  init(adapter: AnalyticsAdapter, enabled: boolean, isProd: boolean): void {
    this.adapter = adapter;
    this.enabled = enabled;
    this.isProd = isProd;
  }

  track(data: TrackParams): void {
    if (!this.enabled || !this.adapter) return;
    const { name, params } = data;
    Promise.resolve(this.adapter.logEvent(name, params as Record<string, unknown>)).catch((e) => {
      if (!this.isProd) console.warn("[Analytics] logEvent error:", e);
    });
  }

  setUserId(userId: string): void {
    if (!this.enabled || !this.adapter) return;
    Promise.resolve(this.adapter.setUserId(userId)).catch((e) => {
      if (!this.isProd) console.warn("[Analytics] setUserId error:", e);
    });
  }

  setUserProperties(properties: Record<string, string | undefined>): void {
    if (!this.enabled || !this.adapter) return;
    Object.entries(properties).forEach(([key, value]) => {
      if (value === undefined) return;
      Promise.resolve(this.adapter!.setUserProperty(key, value)).catch((e) => {
        if (!this.isProd) console.warn("[Analytics] setUserProperty error:", e);
      });
    });
  }
}

export const analyticsCore = new AnalyticsCore();

export const track = (data: TrackParams): void => analyticsCore.track(data);

export const setUserId = (userId: string): void => analyticsCore.setUserId(userId);

export const setUserProperties = (properties: Record<string, string | undefined>): void =>
  analyticsCore.setUserProperties(properties);
